module.exports = __webpack_public_path__ + "img/newSolution_bg1.68a94db.jpg";